import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { Image } from '../image/image';
const b = bemClassBuilder('v-hero-banner');
export const HeroBanner = props => {
    const { className, children } = props, imageProps = __rest(props, ["className", "children"]);
    return (_jsxs("div", Object.assign({ className: b.block(undefined, className) }, { children: [_jsx(Image, Object.assign({}, imageProps, { className: b.element('image') })), _jsx("div", Object.assign({ className: b.element('wrapper') }, { children: children }))] })));
};
HeroBanner.displayName = 'HeroBanner';
